var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframeref",attrs:{"id":_vm.iframeId,"src":_vm.iframeUrl,"frameborder":"0","name":"iframeWrapper"}})
}
var staticRenderFns = []

export { render, staticRenderFns }